import React from 'react'
import ProjectCarousal from './ProjectCarousal'

function Projects() {
  return (
    <div>
       <div className=" d-flex justify-content-center p-2" style={{color: "#15545f", backgroundColor: "#15545f73"}}>
            <h2 className="fw-bold display-6">Projects</h2>
        </div>
        <ProjectCarousal />
    </div>
  )
}

export default Projects